import React, { Component } from 'react';

class EntityTag extends Component {
  
  static defaultProps = {
    entityValue : "UNDEFINED",
  }
  
  state = {

  }
  render() { 
    const { entityValue } = this.props;
    return (
      <p className="entity-value tag">
        {entityValue}
        <button className="delete-this-value-btn"> X </button>
      </p>
    );
  }
}
 
export default EntityTag;
